module.exports = __webpack_public_path__ + "static/media/lapaksahabat.0139037f.png";